export default __webpack_public_path__ + "static/DSC_0409-3ed1117b7d838d7d857f23637df2854e.jpg";